// « Légendes IA » (staff) — worker routes/ai.ts POST /ai/captions/preview.
// A file of its own so lib/api.ts (edited by every parallel piece of work) is
// not touched. The worker WRITES NOTHING: the editor applies the captions.
import { apiFetch } from './api';

export type CaptionLangCode = 'fr' | 'es' | 'en' | 'ar' | 'darija';

export interface CaptionPreviewResult {
  ok: true;
  languages: CaptionLangCode[];
  facts: string[];
  quote?: boolean;
  captions: Array<{ photo: string; text: string; gloss?: string; seen?: string }>;
  meta: Record<string, { width: number; height: number; faces: Array<{ x: number; y: number; width: number; height: number }> }>;
  failed: Array<{ photo: string; why: string }>;
  gapMm?: number;
  /** « Une légende pour la page » (page_groups): one caption per page. */
  pageCaptions?: Array<{ page: number; text: string; gloss?: string }>;
  pageFailed?: Array<{ page: number; why: string }>;
}

export const captionsApi = {
  /** `limits`: each photo's model text box — the longest line its words may have (captionLayout.captionTargets). */
  preview: (body: { session_id: string; languages: CaptionLangCode[]; facts: string[]; pages?: number[]; photo_ids?: string[]; quote?: boolean; limits?: Record<string, number>;
    /** One caption per page: the model sees all the page's photos together. */
    page_groups?: Array<{ page: number; photo_ids: string[]; max_chars?: number }>;
    /** « Consignes du client »: what the client asked for, in the team's words — the model follows it. */
    instructions?: string }) =>
    apiFetch<CaptionPreviewResult>('/ai/captions/preview', { method: 'POST', body: JSON.stringify(body) }),
};
